export default {
    getBodyHeight: function () {
        // 在DOM渲染数据时，设置下区域高度为浏览器可视区域高度．
        this.clientHeight = document.body.clientHeight||document.documentElement.clientHeight;
        // 监听window的resize事件．在浏览器窗口变化时再设置下区域高度．
        const _this = this;
        window.onresize = function temp() {
            _this.clientHeight = document.body.clientHeight||document.documentElement.clientHeight;
        };
        //console.log("当前浏览器可视高度："+_this.clientHeight)
        if(_this.clientHeight<800){
            _this.clientHeight=500
        }else if(_this.clientHeight>800){
            _this.clientHeight=600
        }else{
            _this.clientHeight=600
        }
        return _this.clientHeight
    }
}